import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full h-[52px] bg-navy flex items-center justify-between px-6 lg:px-12 shadow-sm" data-id="element-165">
      <div className="font-sans font-bold text-white text-sm tracking-wider" data-id="element-166">
        GoDeskCore
      </div>
      <a href="#offer" className="bg-burnt text-white font-sans font-bold text-xs rounded-md py-2 px-5 hover:brightness-90 transition-all duration-200 no-underline" data-id="element-167">
        Sí, quiero mi copia &rarr;
      </a>
    </header>;
}